<script>
    import Button, {Group, GroupItem, Label, Icon} from '@smui/button';
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    export let canContinue = false, navigationLink
</script>
<div class="trailing-button mt-2">
    {#if canContinue}
        <div><Button class="mdc-button next" variant="raised" href={navigationLink}><Label>Volgende Stap</Label><Icon class="material-icons">arrow_forward</Icon></Button></div>
    {:else}
        <div><Button variant="raised" disabled><Label>Volgende Stap</Label><Icon class="material-icons">arrow_forward</Icon></Button></div>
    {/if}
</div>
